import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";

const AccessibilityFeedback = () => {
    const { get: getMicrocopy } = useMicrocopy();
    const accessibilityFeedbackMicrocopy = getMicrocopy(
        CommonCMS.shared,
        CommonCMS.accessibilityFeedback
    );
    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
            data-ae-client-feedback-link="true"
            href="#"
            style={{ fontWeight: "bold", textDecoration: "underline" }}
        >
            {accessibilityFeedbackMicrocopy}
        </a>
    );
};
export default AccessibilityFeedback;
